import { FC } from 'react'
import {
    HorizontalScroller,
    QuickStatInsightView,
    QuickStatInsightViewProps,
} from '../molecules'
import Typography from '@mui/material/Typography'
import { customDarkBlueColor } from '../../lib/styles/universal'
import Box from '@mui/material/Box'
interface QuickStatInsightListProps {
    data: QuickStatInsightViewProps[]
    title?: string
    subtitle?: string[]
}

export const QuickStatInsightList: FC<QuickStatInsightListProps> = ({
    title,
    subtitle,
    data: insights,
}) => {
    if (insights.length === 0) return null
    return (
        <Box
            mt={subtitle ? { xs: '-1rem', md: '-2rem' } : undefined}
            style={{
                overflowX: 'auto',
            }}
        >
            {title && (
                <Typography
                    variant="h4"
                    color={customDarkBlueColor}
                >
                    {title}
                </Typography>
            )}
            {subtitle && subtitle.length > 0 && (
                <Box mb="1rem">
                    {subtitle.map((sub, index) => (
                        <Typography
                            key={index}
                            variant="body2"
                            color={customDarkBlueColor}
                        >
                            {sub}
                        </Typography>
                    ))}
                </Box>
            )}
            <HorizontalScroller>
                {insights.map((insight) => (
                    <QuickStatInsightView
                        {...insight}
                        key={insight.placement_id}
                    />
                ))}
            </HorizontalScroller>
        </Box>
    )
}
